import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.typed-array.sort.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { FastDomNode } from '../../../base/browser/fastDomNode.js';
import { ViewEventHandler } from '../../common/viewModel/viewEventHandler.js';
export var ViewPart = /*#__PURE__*/function (_ViewEventHandler) {
  _inherits(ViewPart, _ViewEventHandler);

  var _super = _createSuper(ViewPart);

  function ViewPart(context) {
    var _this;

    _classCallCheck(this, ViewPart);

    _this = _super.call(this);
    _this._context = context;

    _this._context.addEventHandler(_assertThisInitialized(_this));

    return _this;
  }

  _createClass(ViewPart, [{
    key: "dispose",
    value: function dispose() {
      this._context.removeEventHandler(this);

      _get(_getPrototypeOf(ViewPart.prototype), "dispose", this).call(this);
    }
  }]);

  return ViewPart;
}(ViewEventHandler);
export var PartFingerprints = /*#__PURE__*/function () {
  function PartFingerprints() {
    _classCallCheck(this, PartFingerprints);
  }

  _createClass(PartFingerprints, null, [{
    key: "write",
    value: function write(target, partId) {
      if (target instanceof FastDomNode) {
        target.setAttribute('data-mprt', String(partId));
      } else {
        target.setAttribute('data-mprt', String(partId));
      }
    }
  }, {
    key: "read",
    value: function read(target) {
      var r = target.getAttribute('data-mprt');

      if (r === null) {
        return 0
        /* None */
        ;
      }

      return parseInt(r, 10);
    }
  }, {
    key: "collect",
    value: function collect(child, stopAt) {
      var result = [],
          resultLen = 0;

      while (child && child !== document.body) {
        if (child === stopAt) {
          break;
        }

        if (child.nodeType === child.ELEMENT_NODE) {
          result[resultLen++] = this.read(child);
        }

        child = child.parentElement;
      }

      var r = new Uint8Array(resultLen);

      for (var i = 0; i < resultLen; i++) {
        r[i] = result[resultLen - i - 1];
      }

      return r;
    }
  }]);

  return PartFingerprints;
}();